<template>
  <div class="risk_live__pie_echart">
    <div class="top">
      <div style="width: 100%;" class="pie_echart" ref="pieEchart"></div>
    </div>
    <div class="bottom">
      <div class="pie_echart" ref="pieEchart1"></div>
      <div class="pie_echart" ref="pieEchart2"></div>
    </div>
  </div>
</template>

<script>
import echarts from '@/config/echarts'
import { pieOption1 } from '@/config/echarts/option/data-center'
import { apiData } from '@/api'
export default {
  props: {
    theme: {
      type: String,
      default: 'dark'
    }
  },
  data() {
    return {
      myEcharts: [],
      datas: [],
      title: ['风险提醒', '天气提醒', '天气专报']
    }
  },
  watch: {
    theme(newTheme) {
      this.$nextTick(() => {
        this.resizeEchart(newTheme)
      })
    }
  },
  created() {
    this.nowRiskCount()
  },
  mounted() {
    this.myEcharts.push(echarts.init(this.$refs.pieEchart), echarts.init(this.$refs.pieEchart1), echarts.init(this.$refs.pieEchart2))
    window.addEventListener('resize', () => {
      this.$nextTick(() => {
        this.resizeEchart(this.theme)
      })
    })
  },
  methods: {
    resizeEchart(newTheme) {
      this.myEcharts.forEach((echart, index) => {
        echart.setOption(pieOption1(newTheme, this.myEcharts[index], this.datas[index], this.title[index]))
        echart.resize()
      })
    },

    async nowRiskCount() {
      const company = this.$route.query.company
      const { unit } = JSON.parse(localStorage.getItem(company))

      const riskResult = await apiData.riskHisCount(unit.id)
      const riskData = [
        { value: riskResult.data.monthCount, name: '当月' + riskResult.data.monthCount + '次' },
        { value: riskResult.data.weekCount, name: '当周' + riskResult.data.weekCount + '次' },
        { value: riskResult.data.yearCount, name: '当年' + riskResult.data.yearCount + '次' },
        { value: riskResult.data.dayCount, name: '当日' + riskResult.data.dayCount + '次' }
      ]
      this.myEcharts[0].setOption(pieOption1(this.theme, this.myEcharts[0], riskData, this.title[0]))

      const txMsgResult = await apiData.txMsgCount(unit.id)
      const tmData = [
        { value: txMsgResult.data.monthCount, name: '当月' + txMsgResult.data.monthCount + '次' },
        { value: txMsgResult.data.weekCount, name: '当周' + txMsgResult.data.weekCount + '次' },
        { value: txMsgResult.data.yearCount, name: '当年' + txMsgResult.data.yearCount + '次' }
      ]
      this.myEcharts[1].setOption(pieOption1(this.theme, this.myEcharts[1], tmData, this.title[1]))

      const zhunabaoResult = await apiData.zhuanBaoCount({ unitid: unit.id })
      const zbData = [
        { value: zhunabaoResult.data.monthCount, name: '当月' + zhunabaoResult.data.monthCount + '次' },
        { value: zhunabaoResult.data.weekCount, name: '当周' + zhunabaoResult.data.weekCount + '次' },
        { value: zhunabaoResult.data.yearCount, name: '当年' + zhunabaoResult.data.yearCount + '次' }
      ]
      this.myEcharts[2].setOption(pieOption1(this.theme, this.myEcharts[2], zbData, this.title[2]))

      this.datas.push(riskData, tmData, zbData)
    },
    changeIndex(index) {
      this.tabIndex = index
      this.optionData = this.calculateRatio(this.riskData[index])
      this.myEchart.setOption(pieOption1(this.theme, this.myEchart, this.optionData))
    }
  }
}
</script>

<style lang="less" scoped>
.risk_live__pie_echart {
  display: flex;
  flex-direction: column;
  flex: 1;

  .top,
  .bottom {
    display: flex;
    justify-content: center;
    flex: 1;
    overflow: hidden;
  }

  .pie_echart {
    height: 100%;
    width: 50%;
  }

  .tabs_dark {
    .tab_item {
      color: #FFFFFF;
    }

    .tab_item.active {
      font-weight: 500;
      color: #54A6FA;
      border-bottom: 0.21vw solid #52A3FA;
    }
  }
}
</style>
